/* ═══════════════════════════════════════════════════════════
   js/flat-overlay.js — Оверлей квартиры в каталоге (Фаза 5)
   Загружает данные через flat_api.php и показывает в overlay.
   Вызывается из flats.js через window.openFlatOverlay(id).
   Фаза 3: базовый оверлей, share/save/hide
   Фаза 5: carousel фото, похожие квартиры
   ═══════════════════════════════════════════════════════════ */
(() => {
  'use strict';

  // 5.5 fix-раунд (P3 data-верификатора): фолбэк обязан экранировать и кавычки —
  // esc() используется в href/src-атрибутах (textContent→innerHTML кавычки не трогает).
  const esc = window.escHtml || (s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])));
  const API = '/flat_api.php';
  const fmt = n => n >= 1e6 ? (n / 1e6).toFixed(n >= 1e7 ? 1 : 2).replace('.', ',') + ' млн \u20bd' : new Intl.NumberFormat('ru-RU').format(n) + ' \u20bd';
  const fmtFull = n => new Intl.NumberFormat('ru-RU').format(n) + ' ₽';
  const fmtArea = a => { const n = parseFloat(a); return n % 1 === 0 ? n.toFixed(0) : n.toFixed(1); };

  // PERF-3 (2026-08-03): зеркало серверного thumbProxyUrl() — одна политика картинок на
  // сервере и в JS. Кадр оверлея ~800 px, поэтому ширина 1200 с запасом на ретину:
  // планировку разглядывают, ужимать её сильнее нельзя.
  const thumbUrl = (src, w) => {
    if (!src || typeof src !== 'string') return src || '';
    if (!/^https?:\/\//i.test(src)) return src;
    return '/img-thumb.php?src=' + encodeURIComponent(src) + '&w=' + (w || 1200);
  };

  // СТЕНД: та же калитка, что у Метрики и у остальных отрисовщиков (доводка 3
  // блока 2.1). Нужна ровно одному месту — лупе, которая отдаёт кадры общему
  // лайтбоксу СЫРЫМИ (сам оверлей рисует их через thumbUrl() и на проде, и на
  // стенде). Среди этих кадров бывает поэтажный план — тот самый floor_scheme_url
  // из находки 27. На проде адрес остаётся прежним: сравнение строгое.
  const standSrc = (url, w) => (window.BRONIDOM_STAND === true ? thumbUrl(url, w) : url);

  const calcMonthly = window.calcMonthly || ((price, downPct, rate, years) => {
    const p = price * (1 - downPct / 100), mr = rate / 100 / 12, n = years * 12;
    return mr === 0 ? Math.round(p / n) : Math.round(p * (mr * Math.pow(1 + mr, n)) / (Math.pow(1 + mr, n) - 1));
  });
  function buyAbilityClass(monthly) {
    if (monthly <= 30000) return 'buyability-green';
    if (monthly <= 60000) return 'buyability-yellow';
    return 'buyability-red';
  }
  function roomsLabel(r) { r = parseInt(r, 10); return r === 0 ? 'Студия' : r + '-комн.'; }

  // 5.5: валидация URL картинки перед рендером (урок конвейера #5 — scheme/host).
  // Разрешаем только https + непустой host. Блокирует http:/javascript:/data:/битые.
  function isSafeImageUrl(u) {
    if (typeof u !== 'string' || u === '') return false;
    try {
      const p = new URL(u, location.origin);
      return p.protocol === 'https:' && p.hostname !== '';
    } catch { return false; }
  }

  // block #29 (SSOT завершён): URL поэтажного плана берём из ГОТОВОГО серверного поля
  // flat.floor_scheme_url. Его вычисляет FlatHandler::get через LayoutPolicy::isFloorScheme
  // (тот же SSOT, что раздел «Поэтажный план» на flat.php) + каскад по (корпус, секция,
  // этаж). JS БОЛЬШЕ НЕ выбирает кадр из photos[] по имени файла — классификатор жил в
  // одном месте (PHP), клиент лишь читает флаг. Пусто/небезопасно → '' (graceful-hide).
  function floorPlanUrl(flat) {
    const u = flat.floor_scheme_url;
    return (typeof u === 'string' && isSafeImageUrl(u)) ? u : '';
  }

  // ⛔ БЛОКА «НА ЭТАЖЕ» ЗДЕСЬ БОЛЬШЕ НЕТ. До 28.08.2026 окно печатало поэтажный
  // план квартиры отдельным блоком внизу. Владелец распорядился убрать его
  // дословно: «убери оттуда поэтажный план… а блок поэтажный план там не нужен».
  // Убран ЦЕЛИКОМ, а не спрятан оформлением: скрытый блок продолжал бы стоять в
  // разметке, а его картинку (пусть и lazy) пришлось бы каждый раз объяснять.
  // Поле `floor_scheme_url` при этом живо — см. floorPlanUrl выше: поэтажник
  // остаётся кадром-героем, когда своей планировки у квартиры нет.

  // Отделка — ОТДЕЛЬНОЙ СТРОКОЙ ПОД ФАКТАМИ, а не девятой ячейкой сетки
  // характеристик. Владелец назвал её среди главного в окне, а в сетке она
  // лежала заведомо ниже сгиба (замер 28.08.2026: сетка начиналась за 1200 px).
  // ⛔ Пробовали пятой таблеткой ВНУТРЬ строки фактов — «Отделка предчистовая»
  // разгоняла ряд с двух строк до трёх (390 px: 80 → 124 px), то есть в высоте
  // не выигрывали ничего, а читать ряд становилось труднее. Оставлена своей
  // строкой; золотую засечку ей даёт css/flat-overlay.css по селектору
  // `.flat-overlay-body > .flat-overlay-char` — внутри сетки ячейки лежат глубже
  // и этого правила не видят.
  // Graceful-hide: нет отделки → пустая строка, без прочерка.
  function buildDecorationRow(flat) {
    if (!flat.decoration) return '';
    return '<div class="flat-overlay-char">'
      + '<span class="flat-overlay-char-icon"><i class="fa-solid fa-paint-roller"></i></span>'
      + '<span class="flat-overlay-char-label">Отделка</span>'
      + '<span class="flat-overlay-char-value">' + esc(String(flat.decoration)) + '</span>'
      + '</div>';
  }

  // 5.4: характеристики квартиры из фидов (парсятся FeedHandler, лежат в get()-payload).
  // Показываем ТОЛЬКО заполненные (graceful-hide) — без прочерков. Иконки FA free.
  function buildOverlayChars(flat) {
    const items = [];
    const la = parseFloat(flat.living_area) || 0;
    const ka = parseFloat(flat.kitchen_area) || 0;
    const ch = parseFloat(flat.ceiling_height) || 0;
    const balc = parseInt(flat.balconies, 10) || 0;
    const logg = parseInt(flat.loggias, 10) || 0;
    const wcS = parseInt(flat.wc_separate, 10) || 0;
    const wcC = parseInt(flat.wc_combined, 10) || 0;
    if (la > 0) items.push({ icon: 'fa-couch', label: 'Жилая', value: fmtArea(la) + ' м²' });
    if (ka > 0) items.push({ icon: 'fa-utensils', label: 'Кухня', value: fmtArea(ka) + ' м²' });
    // ⛔ ОТДЕЛКИ ЗДЕСЬ НЕТ НАМЕРЕННО — она уехала отдельной строкой под факты
    // (buildDecorationRow). Вернуть её сюда значит показать одно и то же дважды.
    // ⚠️ Формат синхронизирован с js/flat.js renderSpecs (лоджия/балкон/санузел) —
    // владелец 05.07: отдельные строки, «Есть» при 1, санузел словами. Дрейф между
    // файлами ловит tests/Integration/flat-specs-balcony-loggia.test.mjs.
    if (logg > 0) items.push({ icon: 'fa-door-open', label: 'Лоджия', value: logg > 1 ? String(logg) : 'Есть' });
    if (balc > 0) items.push({ icon: 'fa-door-open', label: 'Балкон', value: balc > 1 ? String(balc) : 'Есть' });
    if (wcS > 0 || wcC > 0) {
      const wc = [];
      if (wcS > 0) wc.push(wcS > 1 ? wcS + ' раздельных' : 'Раздельный');
      if (wcC > 0) wc.push(wcC > 1 ? wcC + ' совмещённых' : (wcS > 0 ? 'совмещённый' : 'Совмещённый'));
      items.push({ icon: 'fa-bath', label: 'Санузел', value: wc.join(', ') });
    }
    if (flat.windows_view) items.push({ icon: 'fa-mountain-sun', label: 'Вид из окон', value: String(flat.windows_view) });
    if (ch > 0) items.push({ icon: 'fa-arrows-up-down', label: 'Потолки', value: fmtArea(ch) + ' м' });
    if (flat.section) items.push({ icon: 'fa-building', label: 'Корпус', value: String(flat.section) });
    if (items.length === 0) return '';
    return '<div class="flat-overlay-chars">'
      + items.map(s =>
          '<div class="flat-overlay-char">'
          + '<span class="flat-overlay-char-icon"><i class="fa-solid ' + s.icon + '"></i></span>'
          + '<span class="flat-overlay-char-label">' + esc(s.label) + '</span>'
          + '<span class="flat-overlay-char-value">' + esc(s.value) + '</span>'
          + '</div>'
        ).join('')
      + '</div>';
  }

  // 12.07 доп. (владелец): заметная primary-CTA «Забронировать» в зоне платежа —
  // между чипом «₽/мес» и рядом Поделиться/Сохранить. Обычная <a> (не кнопка + JS):
  // Ctrl-клик / индексация / средняя кнопка живы, inline-handler'ов нет (CSP). Ведёт
  // на карточку квартиры с автофокусом формы брони (flat.js читает book=1 → scroll+focus).
  // id источник — тот же flat.id, что и «Подробнее» ниже. graceful-hide при пустом id.
  function buildBookButton(flat) {
    const id = parseInt(flat.id, 10) || 0;
    if (id <= 0 || flat.status !== 'available') return '';
    return '<a href="/flat.php?id=' + esc(String(id)) + '&book=1" class="flat-btn-primary flat-overlay-book-btn" data-ym="flat_overlay_book">'
      + '<i class="fa-solid fa-calendar-check"></i> Забронировать</a>';
  }

  // ── Favorites / Hidden (shared keys with flat.js) ──
  const FAVS_KEY = 'bronidom_flat_favs';
  const HIDE_KEY = 'bronidom_flat_hidden';
  function getFavs() { try { return JSON.parse(localStorage.getItem(FAVS_KEY)) || []; } catch { return []; } }
  function setFavs(arr) { localStorage.setItem(FAVS_KEY, JSON.stringify(arr)); }
  function isFav(id) { return getFavs().includes(id); }
  function toggleFav(id) {
    const favs = getFavs();
    const idx = favs.indexOf(id);
    if (idx >= 0) favs.splice(idx, 1); else favs.push(id);
    setFavs(favs);
    return idx < 0;
  }
  function hideFlat(id) {
    const h = (function() { try { return JSON.parse(localStorage.getItem(HIDE_KEY)) || []; } catch { return []; } })();
    if (!h.includes(id)) { h.push(id); localStorage.setItem(HIDE_KEY, JSON.stringify(h)); }
  }

  let overlay = null;
  let prevUrl = null;
  let abortCtrl = null;

  function close() {
    if (!overlay) return;
    overlay.remove();
    overlay = null;
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    // Restore URL (только модальный режим менял URL — в неблокирующем prevUrl=null)
    if (prevUrl) {
      history.pushState({}, '', prevUrl);
      prevUrl = null;
    }
    // jk-inline: сообщить странице — снять подсветку активной строки (floorplans.js слушает).
    // Guard: CustomEvent/dispatchEvent могут отсутствовать в тест-песочнице (vm) → пропуск.
    if (typeof CustomEvent === 'function' && document.dispatchEvent) {
      try { document.dispatchEvent(new CustomEvent('bronidom:flat-overlay-close')); } catch (_e) { /* noop */ }
    }
  }

  function onKey(e) {
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') carouselNav(-1);
    if (e.key === 'ArrowRight') carouselNav(1);
  }

  // Скелетон-панель на время фетча (используется при создании и при свап-замене).
  const PANEL_SKELETON =
      '<button class="flat-overlay-close" aria-label="Закрыть"><i class="fa-solid fa-xmark"></i></button>'
    + '<div class="flat-overlay-loading"><div class="flat-overlay-spinner"></div></div>';

  // opts.modal (default true): true — модальный (каталог flats.php: бэкдроп затемняет,
  // лочит скролл, меняет URL). false — неблокирующий (jk.php из модалки планировок:
  // бэкдроп прозрачный + pointer-events:none, список этажей под панелью кликабелен,
  // URL/скролл не трогаем). Повторный вызов при открытой панели = замена контента НА
  // МЕСТЕ (панель пересоздаётся для свежих делегатов, контейнер/URL/скролл сохраняются).
  window.openFlatOverlay = async function(flatId, opts) {
    opts = opts || {};
    const modal = opts.modal !== false;

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    const swapping = !!overlay;

    if (!swapping) {
      // Save current URL, push flat URL — только модальный режим.
      if (modal) {
        prevUrl = location.href;
        history.pushState({ flatOverlay: flatId }, '', '/flat.php?id=' + flatId);
      } else {
        prevUrl = null;
      }

      // Create overlay
      overlay = document.createElement('div');
      overlay.className = 'flat-overlay' + (modal ? '' : ' flat-overlay--inline');
      overlay.innerHTML =
        '<div class="flat-overlay-backdrop"></div>'
      + '<div class="flat-overlay-panel">' + PANEL_SKELETON + '</div>';

      document.body.appendChild(overlay);
      if (modal) document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKey);

      // Close handlers
      overlay.querySelector('.flat-overlay-backdrop').addEventListener('click', close);
      overlay.querySelector('.flat-overlay-close').addEventListener('click', close);
    } else {
      // Свап НА МЕСТЕ: пересоздаём ТОЛЬКО панель (свежие делегаты, без утечки старого
      // flat в замыкании), сохраняя контейнер/бэкдроп/URL/скролл-лок.
      const oldPanel = overlay.querySelector('.flat-overlay-panel');
      const newPanel = document.createElement('div');
      // --swap: без повторного слайд-выезда (анимация только при первом открытии).
      newPanel.className = 'flat-overlay-panel flat-overlay-panel--swap';
      newPanel.innerHTML = PANEL_SKELETON;
      if (oldPanel) oldPanel.replaceWith(newPanel); else overlay.appendChild(newPanel);
      newPanel.querySelector('.flat-overlay-close').addEventListener('click', close);
      // Модальный: обновить URL без новой записи истории (свап не плодит back-стек).
      if (modal) history.replaceState({ flatOverlay: flatId }, '', '/flat.php?id=' + flatId);
    }

    // Fetch flat data
    try {
      const res = await fetch(API + '?action=get&id=' + flatId, { signal: abortCtrl.signal });
      const data = await res.json();
      if (!overlay) return;
      // Даже устаревший/ошибочный успешный payload снятого лота не рисует карточку.
      if (res.status === 410 || data.status === 'hidden' || data.flat?.status === 'hidden') {
        const ld = overlay.querySelector('.flat-overlay-loading');
        if (ld) ld.innerHTML = '<div class="flat-overlay-error">Квартира продана или снята с продажи</div>';
        return;
      }
      if (!data.ok || !data.flat) {
        const ld = overlay.querySelector('.flat-overlay-loading');
        if (ld) ld.innerHTML = '<div class="flat-overlay-error">Квартира не найдена</div>';
        return;
      }
      renderOverlay(data.flat);
    } catch (err) {
      if (err.name === 'AbortError') return;
      if (overlay) {
        const ld = overlay.querySelector('.flat-overlay-loading');
        if (ld) ld.innerHTML = '<div class="flat-overlay-error">Ошибка загрузки</div>';
      }
    }

    // Increment view
    fetch(API + '?action=view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: flatId }),
      signal: abortCtrl ? abortCtrl.signal : undefined,
    }).catch(() => {});
  };

  // Публичный close — для страничных автозакрытий (jk.php: свернул аккордеон /
  // закрыл модалку планировок / сменил тип планировки → window.closeFlatOverlay?.()).
  window.closeFlatOverlay = close;

  // popstate: close overlay if user presses back
  window.addEventListener('popstate', () => {
    if (overlay) { overlay.remove(); overlay = null; document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); prevUrl = null; }
  });

  // ── Carousel state ──
  let carouselIdx = 0;
  let carouselImgs = [];
  // Чем является каждый кадр — 'plan' или фото. Нужно лайтбоксу: у планировки
  // прозрачный PNG, и на тёмном backdrop её линии не видно, поэтому под план
  // подкладывается белое (kinds в window.openLightbox). Здание-фолбэк — фото,
  // ему белая подложка ни к чему.
  let carouselKinds = [];

  function renderOverlay(flat) {
    const panel = overlay.querySelector('.flat-overlay-panel');
    if (!panel) return;

    // block #29 (SSOT завершён): выбор кадра-героя делает СЕРВЕР (FlatHandler::get через
    // LayoutPolicy). hero_plan_url = готовая планировка квартиры (своя чистая / близнец /
    // композит-как-есть); floor_scheme_url = поэтажник этажа; building_image — крайний
    // fallback. JS БОЛЬШЕ НЕ классифицирует layout_url по имени файла: name-based зеркало
    // (window.BroniLayoutImage) удалено — оно не видело широкий композит Догмы (в JS нет
    // размеров картинки). План ЭТАЖА в блоке «На этаже» ниже не дублируем, если он герой.
    const heroPlan = flat.hero_plan_url ? String(flat.hero_plan_url) : '';
    // 28.09.2026 (владелец: «в месте планировки только чертёж»): фото дома героем больше не
    // встаёт. План этажа остаётся резервом (другого места для него в окне нет — блок «На
    // этаже» убран 28.08), но с подписью «План этажа», чтобы его не приняли за план квартиры.
    // Нет ни того, ни другого → заглушка «Планировка уточняется».
    const floorUrl = floorPlanUrl(flat);
    const heroIsFloor = !heroPlan && !!floorUrl;
    const img = heroPlan || floorUrl;
    const allImgs = [];
    if (img) allImgs.push(img);

    carouselImgs = allImgs;
    carouselIdx = 0;
    carouselKinds = allImgs.map(() => 'plan');

    const heroImg = allImgs[0] || '';
    const hasMultiple = allImgs.length > 1;
    // Лупа на главный кадр: 4:3 в окне мало, чтобы разглядеть планировку.
    // ⛔ Через isSafeImageUrl: hero_plan_url и building_image приезжают из фида
    // как есть, и в href они стали бы исполняемыми (`javascript:`) или чужим
    // хостом. Не прошёл проверку — кадр остаётся без лупы (картинка на месте).
    const heroZoom = isSafeImageUrl(heroImg) ? heroImg : '';

    // BuyAbility
    const monthly = flat.status === 'available' && flat.price > 0 ? calcMonthly(flat.price, 20, 6, 25) : 0;
    const baClass = monthly > 0 ? buyAbilityClass(monthly) : '';
    const monthlyHtml = monthly > 0
      ? '<div class="flat-buyability ' + baClass + '"><i class="fa-solid fa-calculator"></i> от ' + esc(new Intl.NumberFormat('ru-RU').format(monthly)) + ' ₽/мес</div>'
      : '';

    // Saved?
    const saved = isFav(flat.id);

    panel.innerHTML =
      '<button class="flat-overlay-close"><i class="fa-solid fa-xmark"></i></button>'
    + '<div class="flat-overlay-scroll">'

    // Hero with carousel
    + '<div class="flat-overlay-hero">'
    + (function () {
        if (!heroImg) return '<div class="flat-overlay-noimg"><i class="fa-solid fa-ruler-combined" aria-hidden="true"></i><span>Планировка уточняется</span></div>';
        var imgHtml = '<img src="' + esc(thumbUrl(heroImg, 1200)) + '" alt="' + esc(roomsLabel(flat.rooms) + ' ' + fmtArea(flat.area) + ' м²') + '" class="flat-overlay-img" id="overlayCarouselImg">';
        // Небезопасный адрес в href не кладём — кадр остаётся просто картинкой.
        if (heroIsFloor) imgHtml += '<span class="flat-overlay-hero-caption">План этажа</span>';
        if (!heroZoom) return imgHtml;
        // <a href> — прогрессивный фолбэк: нет лайтбокса (старый utils.js / JS
        // отвалился) → кадр откроется вкладкой, а не «клик в никуда». Тот же
        // приём, что у поэтажного плана в блоке «На этаже» ниже.
        return '<a href="' + esc(heroZoom) + '" target="_blank" rel="noopener noreferrer"'
          + ' class="flat-overlay-img-zoom"'
          + ' aria-label="Открыть планировку в полном размере">' + imgHtml + '</a>';
      })()
    + (hasMultiple ? '<button class="carousel-arrow carousel-arrow--prev" aria-label="Предыдущее фото"><i class="fa-solid fa-chevron-left"></i></button>' : '')
    + (hasMultiple ? '<button class="carousel-arrow carousel-arrow--next" aria-label="Следующее фото"><i class="fa-solid fa-chevron-right"></i></button>' : '')
    + (hasMultiple ? '<div class="carousel-counter"><span id="overlayCarouselCur">1</span> / ' + allImgs.length + '</div>' : '')
    + '</div>'

    // Price block
    + '<div class="flat-overlay-body">'
    + (flat.status === 'reserved'
      ? '<div class="flat-overlay-status" role="status">Квартира забронирована. Сейчас недоступна для покупки</div>'
      : '')
    + (function(){
        var po = parseInt(flat.price_old, 10) || 0;
        if (po > 0 && po > flat.price) {
          var pct = Math.round((po - flat.price) / po * 100);
          var amt = po - flat.price;
          // Срок акции — ГОТОВАЯ подпись с сервера (FlatHandler::applyDiscountDeadline).
          // Сравнения дат тут нет намеренно: часы браузера принадлежат покупателю,
          // а протухшая акция приезжает как null и плашки не даёт.
          var until = String(flat.discount_until || '');
          return '<div class="flat-overlay-price-old-row">'
            + '<span class="flat-overlay-price-old">' + esc(fmtFull(po)) + '</span>'
            + '<span class="flat-overlay-discount-badge">−' + pct + '% · выгода ' + esc(new Intl.NumberFormat('ru-RU').format(amt)) + ' ₽</span>'
            + (until ? '<span class="flat-overlay-discount-until">' + esc(until) + '</span>' : '')
            + '</div>';
        }
        return '';
      })()
    + '<div class="flat-overlay-price">' + esc(fmtFull(flat.price)) + '</div>'
    + '<div class="flat-overlay-m2">' + esc(new Intl.NumberFormat('ru-RU').format(flat.price_m2)) + ' ₽/м²</div>'
    + monthlyHtml

    // ⛔ ПОРЯДОК ТЕЛА ОКНА ПЕРЕСОБРАН 28.08.2026 ПО ЗАДАНИЮ ВЛАДЕЛЬЦА: «кнопку
    // "Подробнее" нужно выше перенести, чтобы человек сразу её видел при открытии
    // модального окна. Упорядочи это модальное окно без потери качества».
    // Было: кадр → цена → ₽/м² → ₽/мес → Забронировать → Поделиться/Сохранить/
    //       Скрыть → факты → характеристики → ЖК → описание → ПОЭТАЖНЫЙ ПЛАН →
    //       Подробнее/Позвонить → похожие.
    // Стало: цена → ₽/м² → ₽/мес → факты → отделка → Забронировать →
    //       Подробнее/Позвонить → Поделиться/Сохранить/Скрыть → характеристики →
    //       ЖК → описание → похожие.
    // Замер до/после (jsdom высот не даёт, мерено на зеркале): «Подробнее»
    // 1635 → 797 px при высоте экрана 1080, 1616 → 734 при 844; всё окно
    // 2583 → 2256 px. Ни один блок не потерян — переставлены и один убран.
    // ⛔ Порядок закреплён поведенчески: tests/JS/jk-perf-panel-31-07.test.js.

    // Факты о квартире — сразу под ценой: ровно за ними окно и открывают.
    + '<div class="flat-overlay-specs">'
    + '  <span>' + esc(roomsLabel(flat.rooms)) + '</span>'
    + '  <span class="flat-card-dot">·</span>'
    + '  <span>' + esc(fmtArea(flat.area)) + ' м²</span>'
    + '  <span class="flat-card-dot">·</span>'
    + '  <span>' + esc(String(flat.floor)) + (flat.floors_total ? '/' + esc(String(flat.floors_total)) : '') + ' эт.</span>'
    + (flat.deadline ? '  <span class="flat-card-dot">·</span><span>' + esc(window.BuildStatus.deadlineLine(flat.deadline)) + '</span>' : '')
    + '</div>'

    // Отделка — своей строкой под фактами (владелец назвал её среди главного).
    + buildDecorationRow(flat)

    // Забронировать — primary CTA в зоне платежа.
    + buildBookButton(flat)

    // CTA. ⛔ «Подробнее» СТОИТ ЗДЕСЬ, А НЕ ВНИЗУ: это второй по частоте выход из
    // окна, и полтора экрана прокрутки до него человек не проходил.
    + '<div class="flat-overlay-cta">'
    + '  <a href="/flat.php?id=' + esc(String(flat.id)) + '" class="flat-btn-primary flat-overlay-full-btn">Подробнее</a>'
    + '  <a href="tel:+79191701918" class="flat-btn-secondary flat-overlay-call-btn"><i class="fa-solid fa-phone"></i> Позвонить</a>'
    + '</div>'

    // Actions — служебный ряд, УШЁЛ ПОД действия: раньше он стоял между бронью и
    // фактами и весил на экране столько же, сколько покупка квартиры.
    + '<div class="flat-actions">'
    + '  <button class="flat-action-btn" data-action="share"><i class="fa-solid fa-arrow-up-from-bracket"></i> Поделиться</button>'
    + '  <button class="flat-action-btn' + (saved ? ' flat-action-active' : '') + '" data-action="save"><i class="fa-' + (saved ? 'solid' : 'regular') + ' fa-heart"></i> ' + (saved ? 'Сохранено' : 'Сохранить') + '</button>'
    + '  <button class="flat-action-btn" data-action="hide"><i class="fa-regular fa-eye-slash"></i> Скрыть</button>'
    + '</div>'

    // 5.4: характеристики из фидов (граceful-hide, пустое не рендерится)
    + buildOverlayChars(flat)

    // JK info
    + '<div class="flat-overlay-jk">'
    + '  <a href="' + esc(jkHref({ id: flat.building_id, url: flat.building_url })) + '" class="flat-overlay-jk-name">' + esc(flat.building_name || '') + '</a>'
    + '  <div class="flat-overlay-dev">' + esc(flat.developer || '') + '</div>'
    + '  <div class="flat-overlay-addr">' + esc(flat.address || '') + '</div>'
    + '</div>'

    // Description
    + (flat.description ? '<div class="flat-overlay-desc">' + esc(flat.description) + '</div>' : '')

    // Similar flats placeholder
    + '<div class="flat-overlay-similar" id="overlaySimilar"></div>'

    + '</div>' // /body
    + '</div>'; // /scroll

    // Re-bind close button (innerHTML replaced it)
    panel.querySelector('.flat-overlay-close').addEventListener('click', close);

    // ── Carousel controls ──
    if (hasMultiple) {
      panel.querySelector('.carousel-arrow--prev').addEventListener('click', () => carouselNav(-1));
      panel.querySelector('.carousel-arrow--next').addEventListener('click', () => carouselNav(1));
    }

    // Bind actions + similar cards (delegation)
    panel.addEventListener('click', (e) => {
      // Забронировать → модалка брони ПОВЕРХ панели (не уходим со страницы ЖК).
      // href flat.php?id=X&book=1 сохранён как progressive-enhancement / SEO fallback:
      // Ctrl/Cmd/Shift/Alt-клик (открыть в новой вкладке) — навигация живёт, модалку не
      // перехватываем. openBookingModal может отсутствовать (booking-modal.js не догрузился)
      // → тогда href-навигация как fallback. Контекст квартиры берём из flat (замыкание).
      const bookBtn = e.target.closest('.flat-overlay-book-btn');
      if (bookBtn) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // новая вкладка — не мешаем
        if (typeof window.openBookingModal === 'function') {
          e.preventDefault();
          window.openBookingModal({
            flat_id: flat.id,
            building_id: flat.building_id,
            building_name: flat.building_name,
            rooms: flat.rooms,
            area: flat.area,
            reserved: String(flat.status || '') === 'reserved',
            source: 'flat_booking',
            context_label: 'панель квартиры (каталог/ЖК)',
          });
        }
        return;
      }
      // Лупа на главный кадр (планировку) → тот же общий лайтбокс. Открываем
      // ВЕСЬ набор кадров с текущей позиции, а не один кадр: иначе из лайтбокса
      // нельзя было бы листать, хотя карусель под ним листается.
      const zoomLink = e.target.closest('.flat-overlay-img-zoom');
      if (zoomLink && carouselImgs.length && window.openLightbox) {
        e.preventDefault();
        window.openLightbox(carouselImgs, carouselIdx, {
          kinds: carouselKinds,
          standSrc: (u) => standSrc(u, 1200),
        });
        return;
      }
      // ⛔ Ветки для поэтажного плана здесь больше нет: блок убран из окна
      // (28.08.2026), и делегат остался бы висеть на цель, которой не бывает.
      // Similar card click
      const simCard = e.target.closest('.similar-card');
      if (simCard) {
        const sid = parseInt(simCard.dataset.flatId, 10);
        if (sid > 0 && window.openFlatOverlay) window.openFlatOverlay(sid);
        return;
      }
      const btn = e.target.closest('[data-action]');
      if (!btn) return;

      const action = btn.dataset.action;
      if (action === 'share') {
        const url = location.href;
        if (navigator.share) {
          navigator.share({ title: document.title, url: url }).catch(() => {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(() => {
            btn.innerHTML = '<i class="fa-solid fa-check"></i> Скопировано';
            setTimeout(() => { btn.innerHTML = '<i class="fa-solid fa-arrow-up-from-bracket"></i> Поделиться'; }, 2000);
          }).catch(() => {});
        }
      } else if (action === 'save') {
        const nowSaved = toggleFav(flat.id);
        btn.innerHTML = '<i class="fa-' + (nowSaved ? 'solid' : 'regular') + ' fa-heart"></i> ' + (nowSaved ? 'Сохранено' : 'Сохранить');
        btn.classList.toggle('flat-action-active', nowSaved);
      } else if (action === 'hide') {
        hideFlat(flat.id);
        btn.innerHTML = '<i class="fa-solid fa-eye-slash"></i> Скрыто';
        btn.classList.add('flat-action-active');
        setTimeout(close, 500);
      }
    });

    // ── Load similar flats ──
    loadSimilar(flat.id);
  }

  // ── Carousel navigation ──
  function carouselNav(dir) {
    if (carouselImgs.length < 2) return;
    carouselIdx = (carouselIdx + dir + carouselImgs.length) % carouselImgs.length;
    const imgEl = document.getElementById('overlayCarouselImg');
    const curEl = document.getElementById('overlayCarouselCur');
    if (imgEl) imgEl.src = thumbUrl(carouselImgs[carouselIdx], 1200); // PERF-3
    // href-фолбэк лупы обязан указывать на ТЕКУЩИЙ кадр, иначе «открыть в
    // полном размере» без лайтбокса показало бы первый кадр вместо видимого.
    // ⛔ Через ту же проверку, что и при первом рендере: сегодня в carouselImgs
    // лежит один заведомо проверенный кадр, но набор собирается из полей фида,
    // и как только карусель станет многокадровой, сюда поедет непроверенный
    // адрес — прямо в href. Не прошёл — лупу снимаем, картинка остаётся.
    const zoomEl = imgEl && imgEl.parentElement
      && imgEl.parentElement.classList.contains('flat-overlay-img-zoom') ? imgEl.parentElement : null;
    if (zoomEl) {
      const next = carouselImgs[carouselIdx];
      if (isSafeImageUrl(next)) zoomEl.href = next;
      else zoomEl.removeAttribute('href');
    }
    if (curEl) curEl.textContent = carouselIdx + 1;
  }

  // ── Load similar flats ──
  function loadSimilar(flatId) {
    const container = document.getElementById('overlaySimilar');
    if (!container) return;

    fetch(API + '?action=similar&id=' + flatId + '&limit=6', { signal: abortCtrl ? abortCtrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!overlay || !d.ok || !d.flats || d.flats.length === 0) return;
        var html = '<div class="similar-title">Похожие квартиры</div><div class="similar-grid">';
        d.flats.forEach(function (s) {
          var sImg = s.layout_url || ''; // 28.09.2026: без фото дома в месте планировки
          html += '<div class="similar-card" data-flat-id="' + esc(String(s.id)) + '">'
            + '<div class="similar-card-img">'
            // ⛔ Ширина 320, а не 1200: это карточка-миниатюра в сетке «похожих»,
            //    сосед по смыслу — flats-showcase.js:1343. На проде адрес прежний.
            + (sImg ? '<img src="' + esc(standSrc(sImg, 320)) + '" alt="" loading="lazy">' : '<div class="similar-card-noimg"><i class="fa-solid fa-building"></i></div>')
            + '</div>'
            + '<div class="similar-card-info">'
            + '<div class="similar-card-price">' + fmt(s.price) + '</div>'
            + '<div class="similar-card-specs">' + esc(roomsLabel(s.rooms)) + ' · ' + esc(fmtArea(s.area)) + ' м²</div>'
            + '<div class="similar-card-jk">' + esc(s.building_name || '') + '</div>'
            + '</div></div>';
        });
        html += '</div>';
        container.innerHTML = html;
      })
      .catch(function () {}); // silent fail
  }

  // 6.4: экспорт чистых билдеров/валидатора для behavioral-тестов (паттерн
  // window.BroniFlatGallery из utils.js). Ничего не меняет в рантайме — рендер
  // по-прежнему идёт через локальные вызовы выше; это лишь тестовое окно, чтобы
  // проверять isSafeImageUrl/graceful-hide исполнением, а не grep'ом исходника.
  if (typeof window !== 'undefined') {
    window.BroniFlatOverlay = {
      isSafeImageUrl: isSafeImageUrl,
      floorPlanUrl: floorPlanUrl,
      buildOverlayChars: buildOverlayChars,
      buildDecorationRow: buildDecorationRow,
      buildBookButton: buildBookButton,
    };
  }
})();
